import { AccountingDocumentStatus } from '@/models/accounting-document.model';

export const ClosedAccountingDocumentStatuses = [AccountingDocumentStatus.Settled] as AccountingDocumentStatus[];

export const DOCUMENT_SELECTION_LIMIT = 20;
